<div class="unsubscribe-container">
    <div class="card">
        <div *ngIf="loading" class="loading-state">
            <div class="spinner-border text-primary" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <p class="mt-3">Processing your request...</p>
        </div>

        <div *ngIf="!loading && success" class="success-state">
            <div class="success-icon">✓</div>
            <h1>Unsubscribed Successfully</h1>
            <p *ngIf="patientName" class="patient-name">Hi {{ patientName }}!</p>
            <p class="message">{{ message }}</p>
            <p class="info-text">
                You will no longer receive email notifications from MyMedsPH.
            </p>
        </div>

        <div *ngIf="!loading && !success" class="error-state">
            <div class="error-icon">✗</div>
            <h1>Unsubscribe Failed</h1>
            <p class="message error-message">{{ message }}</p>
            <p class="info-text">
                The link may have expired or is invalid. Please contact your clinic directly if you need assistance.
            </p>
        </div>

        <div class="footer-text">
            <p>If you have any questions, please contact your clinic directly.</p>
        </div>
    </div>
</div>

